import React from 'react'
import styled from 'styled-components'
import NotFound from 'assets/icons/not_found.svg'

const Page = styled.div`
  text-align: center;
`
const Bold = styled.div`
  font-size: 22px;
  font-weight: bold;
  line-height: 29px;
  margin-top: 40px;
`
const P = styled.p`
  color: ${({ theme }) => theme.colors.textNoMatch};
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  text-align: center;
`

export default function NoMatch() {
  return (
    <Page>
      <object type="image/svg+xml" data={NotFound}>
        Not Found
      </object>
      <Bold>Nothing here</Bold>
      <P>
        Looks like the page you’re looking for does not exist or is not
        available anymore.
      </P>
    </Page>
  )
}
